import { SVGAttributes } from "react";

function BellRingingTilted(props: SVGAttributes<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.7348 18.0148C16.1636 19.6152 15.2139 21.2602 13.6135 21.689C12.0131 22.1178 10.3681 21.1681 9.93923 19.5677M2.1457 11.6133C1.75621 10.2151 2.16125 8.70349 3.19765 7.68738M12.2352 5.74085C12.5394 5.19355 12.6396 4.53205 12.4647 3.87945C12.1074 2.54579 10.7365 1.75433 9.40287 2.11168C8.0692 2.46904 7.27775 3.83988 7.6351 5.17355C7.80997 5.82614 8.2275 6.34891 8.7646 6.67079M20.4079 6.72C20.0461 5.31439 18.9395 4.20779 17.5339 3.84602M17.5795 9.44528C17.2226 8.11315 16.2696 6.99919 14.9304 6.34845C13.5911 5.69772 11.9752 5.56352 10.4381 5.97538C8.90101 6.38724 7.56868 7.31142 6.7342 8.54461C5.89972 9.77779 5.63144 11.219 5.98839 12.5511C6.57896 14.7552 6.46429 16.5135 6.09133 17.8497C5.66627 19.3725 5.45373 20.134 5.51115 20.2869C5.57684 20.4618 5.62436 20.5098 5.79859 20.5773C5.95089 20.6363 6.59066 20.4649 7.8702 20.122L19.7353 16.9428C21.0148 16.5999 21.6546 16.4285 21.757 16.3013C21.8741 16.1557 21.8912 16.0904 21.8607 15.906C21.834 15.7449 21.2692 15.1918 20.1396 14.0855C19.1486 13.1148 18.1701 11.6493 17.5795 9.44528Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export { BellRingingTilted };
